module.exports = __webpack_public_path__ + "static/media/seguridad.abb51c97.png";